import { useEffect, useState } from "react";

export function useBusinessSettings() {
  const [businessType, setBusinessType] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [isEmployee, setIsEmployee] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const business = sessionStorage.getItem("organization_name") || "";
    const businessType = sessionStorage.getItem("business_type") || "";
    const storedColor = sessionStorage.getItem(`background_color${business}`);
    const employeeLogin = sessionStorage.getItem("employee");

    setOrganizationName(business);
    setBusinessType(businessType);
    setIsEmployee(!!employeeLogin);

    if (storedColor) {
      document.documentElement.style.setProperty("--color", storedColor);
    }

    const fontFamily = sessionStorage.getItem(`font_family${business}`);
    if (fontFamily) {
      document.documentElement.style.setProperty("--fontfamily", fontFamily);
    }

    setLoading(false);
  }, []);

  return { businessType, organizationName, isEmployee, loading };
}
